// eslint-disable-next-line import/prefer-default-export
export const menuItems = [
  {
    displayName: 'View details',
    action: 'viewDetails',
    liveModeOnly: true,
  },
  {
    displayName: 'Subscribe',
    action: 'subscribe',
    liveModeOnly: true,
  },
  {
    displayName: 'Disconnect',
    action: 'disconnect',
    liveModeOnly: false,
  },
];
